import React, { Component } from 'react'
import logo from './assets/logo.svg'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { logout } from '../actions/userActions'
import { reset } from '../actions/transactionsActions'

@connect((store)=>{
  return {
    auth: store.user.auth,
    selectedCompany: store.user.selectedCompany,
    userCompanies: store.user.userCompanies
  } 
})
class Header extends Component {

  handleLogout = () => {
    this.props.dispatch(logout())
  }

  handleSelectEmpresa= () => {
    this.props.dispatch(reset(null))
  }

  render() {
    return (
      <header className="App-header">
      <div className="Logo-Container"><Link to="/transactions"><img src={logo} width="200px" alt="logo"/></Link>
      <div className="u-pull-right">{this.props.auth?<Link to="/" onClick={this.handleLogout}>Logout</Link> : null }</div>
      <div className="u-pull-right"> &nbsp; &nbsp; </div>
      {this.props.selectedCompany && this.props.userCompanies.length > 1 ? 
        <div className="u-pull-right">{this.props.auth? <div>
          <span style={{fontWeight:'bold'}}>{this.props.selectedCompany.charAt(0).toUpperCase() + this.props.selectedCompany.slice(1)}
          </span><span style={{color:'#ececec'}}> | </span>
          <Link to="/" onClick={this.handleSelectEmpresa}>Trocar empresa</Link><span style={{color:'#ececec'}}> | </span></div> : null }
      </div> : null }
      </div>
    </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js